module.exports = __webpack_public_path__ + "static/media/Q_2_26.50d58271.png";